import { __decorate } from 'tslib';
import * as i2 from '@angular/common';
import { CommonModule, AsyncPipe } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, TemplateRef, ViewEncapsulation, ContentChildren, Directive, forwardRef, ContentChild, Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WA_WINDOW } from '@ng-web-apis/common';
import { tuiPure, tuiCreateToken, tuiProvideOptions } from '@taiga-ui/cdk/utils/miscellaneous';
import { TuiButton } from '@taiga-ui/core/components/button';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiLoader } from '@taiga-ui/core/components/loader';
import * as i1 from '@taiga-ui/core/directives/appearance';
import { tuiAppearanceOptionsProvider, TuiAppearance, TuiWithAppearance } from '@taiga-ui/core/directives/appearance';
import { TuiHintOverflow } from '@taiga-ui/core/directives/hint';
import { TUI_COMMON_ICONS } from '@taiga-ui/core/tokens';
import { TUI_DIGITAL_INFORMATION_UNITS, TUI_FILE_TEXTS, TUI_HIDE_TEXT, TUI_SHOW_ALL_TEXT, TUI_INPUT_FILE_TEXTS } from '@taiga-ui/kit/tokens';
import { PolymorpheusOutlet, PolymorpheusTemplate, injectContext, PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { map, of, combineLatest, timer, switchMap, filter } from 'rxjs';
import { tuiCreateOptions } from '@taiga-ui/cdk/utils/di';
import { coerceArray } from '@angular/cdk/coercion';
import { tuiRound } from '@taiga-ui/cdk/utils/math';
import { TuiItem } from '@taiga-ui/cdk/directives/item';
import { EMPTY_QUERY, EMPTY_ARRAY, CHAR_NO_BREAK_SPACE } from '@taiga-ui/cdk/constants';
import { TuiExpandComponent } from '@taiga-ui/core/components/expand';
import * as i1$1 from '@taiga-ui/core/directives/group';
import { tuiGroupOptionsProvider, TuiGroup } from '@taiga-ui/core/directives/group';
import { TuiLink } from '@taiga-ui/core/components/link';
import { TuiBreakpointService } from '@taiga-ui/core/services';
import { TuiControl, tuiAsControl } from '@taiga-ui/cdk/classes';
import * as i1$3 from '@taiga-ui/cdk/directives/native-validator';
import { TuiNativeValidator } from '@taiga-ui/cdk/directives/native-validator';
import { tuiZonefreeScheduler, tuiControlValue } from '@taiga-ui/cdk/observables';
import { tuiInjectElement } from '@taiga-ui/cdk/utils/dom';
import { Validators, FormControl } from '@angular/forms';
import * as i1$2 from '@taiga-ui/cdk/directives/validator';
import { TuiValidator } from '@taiga-ui/cdk/directives/validator';
const _c0 = ["*"];
const _c1 = a0 => ({
  $implicit: a0
});
function TuiFile_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r1, " ");
  }
}
function TuiFile_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fileSize_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", fileSize_r2, " ");
  }
}
function TuiFile_div_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r3 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r3, " ");
  }
}
function TuiFile_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, TuiFile_div_10_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const content_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", content_r4);
  }
}
function TuiFile_ng_container_13_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click.prevent", function TuiFile_ng_container_13_button_1_Template_button_click_prevent_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r5 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r5.remove.emit());
    })("mousedown.prevent.zoneless", function TuiFile_ng_container_13_button_1_Template_button_mousedown_prevent_zoneless_0_listener() {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView(0);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const texts_r7 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("iconStart", ctx_r5.icons.close);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", texts_r7.remove, " ");
  }
}
function TuiFile_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiFile_ng_container_13_button_1_Template, 2, 2, "button", 14);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r5.fileTexts$));
  }
}
function TuiFile_ng_template_14_img_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r5.preview, i0.ɵɵsanitizeUrl);
  }
}
function TuiFile_ng_template_14_ng_template_1_tui_loader_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-loader", 19);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("inheritColor", ctx_r5.isBig);
  }
}
function TuiFile_ng_template_14_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiFile_ng_template_14_ng_template_1_tui_loader_0_Template, 1, 1, "tui-loader", 18);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const svg_r8 = i0.ɵɵreference(4);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.isLoading)("ngIfElse", svg_r8);
  }
}
function TuiFile_ng_template_14_ng_template_3_tui_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 21);
  }
  if (rf & 2) {
    const src_r9 = ctx.polymorpheusOutlet;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("t-icon_blank", ctx_r5.isBig || ctx_r5.isDeleted)("t-icon_error", ctx_r5.isError);
    i0.ɵɵproperty("icon", src_r9.toString());
  }
}
function TuiFile_ng_template_14_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiFile_ng_template_14_ng_template_3_tui_icon_0_Template, 1, 5, "tui-icon", 20);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r5.icon)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx_r5.size));
  }
}
function TuiFile_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiFile_ng_template_14_img_0_Template, 1, 1, "img", 16)(1, TuiFile_ng_template_14_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(3, TuiFile_ng_template_14_ng_template_3_Template, 1, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const loader_r10 = i0.ɵɵreference(2);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.preview)("ngIfElse", loader_r10);
  }
}
function TuiFilesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiFilesComponent_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r1);
  }
}
function TuiFilesComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiFilesComponent_ng_container_3_ng_container_1_Template, 1, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const index_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.max || index_r2 < ctx_r2.max);
  }
}
function TuiFilesComponent_tui_expand_4_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r4);
  }
}
function TuiFilesComponent_tui_expand_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiFilesComponent_tui_expand_4_ng_container_2_ng_container_1_Template, 1, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const index_r5 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.max && index_r5 >= ctx_r2.max);
  }
}
function TuiFilesComponent_tui_expand_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tui-expand", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, TuiFilesComponent_tui_expand_4_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("expanded", ctx_r2.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.items);
  }
}
function TuiFilesComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 9);
    i0.ɵɵlistener("click", function TuiFilesComponent_div_5_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggle());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("t-bottom_collapsed", !ctx_r2.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r2.expanded ? ctx_r2.hideText$ : ctx_r2.showAllText$), " ");
  }
}
const _c2 = ["tuiInputFiles", ""];
function TuiInputFiles_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r1, " ");
  }
}
const TUI_SIZE_ERROR = 'tuiSize';
const TUI_FORMAT_ERROR = 'tuiFormat';
function tuiCreateFileSizeValidator(size) {
  return ({
    value
  }) => {
    const files = value && coerceArray(value);
    const $implicit = value && files?.filter(file => file.size > size);
    return $implicit?.length ? {
      [TUI_SIZE_ERROR]: {
        $implicit,
        size
      }
    } : null;
  };
}
function tuiCreateFileFormatValidator(accept) {
  return ({
    value
  }) => {
    const files = value && coerceArray(value);
    const formats = toArray$1(accept);
    const $implicit = value && files?.filter(file => !checkFormat(file, formats));
    return $implicit?.length && accept ? {
      [TUI_FORMAT_ERROR]: {
        $implicit
      }
    } : null;
  };
}
function checkFormat({
  name,
  type
}, formats) {
  const extension = `.${(name.split('.').pop() || '').toLowerCase()}`;
  return formats.some(format => format === extension || format === type || format.split('/')[1] === '*' && type?.split('/')[0] === format.split('/')[0]);
}
function toArray$1(accept) {
  return accept.toLowerCase().split(',').map(format => format.trim().toLowerCase());
}
const BYTES_PER_KIB = 1024;
const BYTES_PER_MIB = 1024 * BYTES_PER_KIB;
function tuiFilesRejected(control) {
  const format = control?.getError(TUI_FORMAT_ERROR)?.$implicit || [];
  const size = control?.getError(TUI_SIZE_ERROR)?.$implicit || [];
  return Array.from(new Set([...format, ...size]));
}
function tuiFilesAccepted(control) {
  const value = control?.value || [];
  const files = coerceArray(value);
  const size = control?.getError(TUI_SIZE_ERROR)?.$implicit || [];
  const format = control?.getError(TUI_FORMAT_ERROR)?.$implicit || [];
  return files.filter(file => !size.includes(file) && !format.includes(file));
}
function tuiFormatSize(units, size) {
  if (size === undefined) {
    return null;
  }
  if (size < BYTES_PER_KIB) {
    return `${size} ${units[0]}`;
  }
  if (size < BYTES_PER_MIB) {
    return `${(size / BYTES_PER_KIB).toFixed(0)} ${units[1]}`;
  }
  return `${tuiRound(size / BYTES_PER_MIB, 2).toLocaleString('ru-RU')} ${units[2]}`;
}
const TUI_FILE_DEFAULT_OPTIONS = {
  appearance: 'outline',
  formatSize: tuiFormatSize,
  icons: {
    normal: ({
      $implicit
    }) => $implicit === 'l' ? '@tui.file' : '@tui.circle-check',
    error: '@tui.circle-alert',
    deleted: '@tui.trash'
  }
};
/**
 * Default parameters for file component
 */
const [TUI_FILE_OPTIONS, tuiFileOptionsProvider] = tuiCreateOptions(TUI_FILE_DEFAULT_OPTIONS);
class TuiFile {
  constructor() {
    this.sanitizer = inject(DomSanitizer);
    this.options = inject(TUI_FILE_OPTIONS);
    this.units$ = inject(TUI_DIGITAL_INFORMATION_UNITS);
    this.win = inject(WA_WINDOW);
    this.icons = inject(TUI_COMMON_ICONS);
    this.fileTexts$ = inject(TUI_FILE_TEXTS);
    this.file = {
      name: ''
    };
    this.state = 'normal';
    this.size = 'm';
    this.showDelete = true;
    this.showSize = true;
    this.remove = new EventEmitter();
  }
  get preview() {
    return this.isBig ? this.createPreview(this.file) : '';
  }
  get isBig() {
    return this.size === 'l';
  }
  get isLoading() {
    return this.state === 'loading';
  }
  get isError() {
    return this.state === 'error';
  }
  get isDeleted() {
    return this.state === 'deleted';
  }
  get allowDelete() {
    return this.showDelete && this.remove.observed;
  }
  get icon() {
    return this.state === 'loading' ? '' : this.options.icons[this.state];
  }
  get name() {
    return this.getName(this.file);
  }
  get type() {
    return this.getType(this.file);
  }
  get content$() {
    return this.calculateContent$(this.state, this.file, this.fileTexts$);
  }
  get fileSize$() {
    return this.calculateFileSize$(this.file, this.units$);
  }
  calculateContent$(state, file, fileTexts$) {
    return state === 'error' && !file.content ? fileTexts$.pipe(map(texts => texts.loadingError)) : of(this.file.content || '');
  }
  calculateFileSize$(file, units$) {
    return units$.pipe(map(units => this.options.formatSize(units, file.size)));
  }
  createPreview(file) {
    if (file.src) {
      return file.src;
    }
    if (this.win.File && file instanceof this.win.File && file.type?.startsWith('image/')) {
      return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
    }
    return '';
  }
  getName(file) {
    const dot = file.name.lastIndexOf('.');
    // a dot at position 0 means a “hidden” file, not an extension
    return dot > 0 ? file.name.slice(0, dot) : file.name;
  }
  getType(file) {
    const dot = file.name.lastIndexOf('.');
    // only return an extension when there is one
    return dot > 0 ? file.name.slice(dot) : '';
  }
  static {
    this.ɵfac = function TuiFile_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TuiFile)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TuiFile,
      selectors: [["tui-file"], ["a", "tuiFile", ""], ["button", "tuiFile", ""]],
      hostVars: 1,
      hostBindings: function TuiFile_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-delete", ctx.showDelete);
        }
      },
      inputs: {
        file: "file",
        state: "state",
        size: "size",
        showDelete: "showDelete",
        showSize: "showSize",
        leftContent: "leftContent"
      },
      outputs: {
        remove: "remove"
      },
      features: [i0.ɵɵProvidersFeature([tuiAppearanceOptionsProvider(TUI_FILE_OPTIONS)]), i0.ɵɵHostDirectivesFeature([i1.TuiAppearance])],
      ngContentSelectors: _c0,
      decls: 16,
      vars: 12,
      consts: [["defaultLeftContent", ""], ["loader", ""], ["svg", ""], [1, "t-preview"], [4, "polymorpheusOutlet"], [1, "t-wrapper"], [1, "t-text"], ["tuiHintOverflow", "", 1, "t-name"], [1, "t-type"], ["class", "t-size", 4, "ngIf"], ["class", "t-content", 4, "ngIf"], [4, "ngIf"], [1, "t-size"], [1, "t-content"], ["appearance", "icon", "size", "xs", "tuiIconButton", "", "type", "button", "class", "t-remove", 3, "iconStart", "click.prevent", "mousedown.prevent.zoneless", 4, "ngIf"], ["appearance", "icon", "size", "xs", "tuiIconButton", "", "type", "button", 1, "t-remove", 3, "click.prevent", "mousedown.prevent.zoneless", "iconStart"], ["alt", "file preview", "class", "t-image", 3, "src", 4, "ngIf", "ngIfElse"], ["alt", "file preview", 1, "t-image", 3, "src"], ["class", "t-loader", 3, "inheritColor", 4, "ngIf", "ngIfElse"], [1, "t-loader", 3, "inheritColor"], ["class", "t-icon", 3, "t-icon_blank", "t-icon_error", "icon", 4, "polymorpheusOutlet", "polymorpheusOutletContext"], [1, "t-icon", 3, "icon"]],
      template: function TuiFile_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵtemplate(1, TuiFile_ng_container_1_Template, 2, 1, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 5)(3, "div", 6)(4, "div", 7);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 8);
          i0.ɵɵtext(7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, TuiFile_div_8_Template, 2, 1, "div", 9);
          i0.ɵɵpipe(9, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, TuiFile_div_10_Template, 2, 1, "div", 10);
          i0.ɵɵpipe(11, "async");
          i0.ɵɵprojection(12);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, TuiFile_ng_container_13_Template, 3, 3, "ng-container", 11)(14, TuiFile_ng_template_14_Template, 5, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const defaultLeftContent_r11 = i0.ɵɵreference(15);
          i0.ɵɵclassProp("t-preview_big", ctx.isBig);
          i0.ɵɵadvance();
          i0.ɵɵproperty("polymorpheusOutlet", ctx.leftContent || defaultLeftContent_r11);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", ctx.name, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.type);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showSize && i0.ɵɵpipeBind1(9, 8, ctx.fileSize$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 10, ctx.content$));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.allowDelete);
        }
      },
      dependencies: [CommonModule, i2.NgIf, i2.AsyncPipe, PolymorpheusOutlet, TuiButton, TuiHintOverflow, TuiIcon, TuiLoader],
      styles: ["[_nghost-%COMP%]{position:relative;display:flex;align-items:center;font:var(--tui-font-text-m);padding:.625rem 2.25rem .625rem .625rem;text-decoration:none;border-radius:var(--tui-radius-m)}[_nghost-%COMP%]:hover   .t-remove[_ngcontent-%COMP%], [data-delete=always][_nghost-%COMP%]   .t-remove[_ngcontent-%COMP%]{opacity:1}.t-preview[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;inline-size:1.5rem;block-size:1.5rem;margin-right:.75rem;border-radius:var(--tui-radius-m);overflow:hidden;color:var(--tui-text-tertiary)}.t-preview_big[_ngcontent-%COMP%]{inline-size:4rem;block-size:4rem;margin-right:1rem}.t-preview_big[_ngcontent-%COMP%]:before{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";background:var(--tui-background-neutral-1)}.t-image[_ngcontent-%COMP%]{max-inline-size:100%;max-block-size:100%}.t-loader[_ngcontent-%COMP%]{position:absolute;top:0;left:0;inline-size:100%;block-size:100%}.t-icon[_ngcontent-%COMP%]{position:absolute;top:0;left:0;bottom:0;right:0;color:var(--tui-status-positive);margin:auto}.t-icon_blank[_ngcontent-%COMP%]{color:var(--tui-text-tertiary)}.t-icon_error[_ngcontent-%COMP%]{color:var(--tui-text-negative)}.t-remove[_ngcontent-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:absolute;top:.625rem;right:.625rem}.t-remove[_ngcontent-%COMP%]:focus{opacity:1}.t-remove[_ngcontent-%COMP%]:focus-visible{box-shadow:inset 0 0 0 2px var(--tui-border-focus)}@media (hover: hover) and (pointer: fine){.t-remove[_ngcontent-%COMP%]{opacity:0}}.t-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;overflow:hidden;color:var(--tui-text-primary)}.t-text[_ngcontent-%COMP%]{display:flex}.t-size[_ngcontent-%COMP%]{flex-shrink:0;opacity:var(--tui-disabled-opacity);margin-left:.5rem}.t-type[_ngcontent-%COMP%]{flex-shrink:0}.t-name[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.t-content[_ngcontent-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-negative)}"],
      changeDetection: 0
    });
  }
}
__decorate([tuiPure], TuiFile.prototype, "calculateContent$", null);
__decorate([tuiPure], TuiFile.prototype, "calculateFileSize$", null);
__decorate([tuiPure], TuiFile.prototype, "createPreview", null);
__decorate([tuiPure], TuiFile.prototype, "getName", null);
__decorate([tuiPure], TuiFile.prototype, "getType", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiFilesComponent = /*#__PURE__*/(() => {
  class TuiFilesComponent {
    constructor() {
      this.items = EMPTY_QUERY;
      this.hideText$ = inject(TUI_HIDE_TEXT);
      this.showAllText$ = inject(TUI_SHOW_ALL_TEXT);
      this.max = 0;
      this.expanded = false;
      this.expandedChange = new EventEmitter();
    }
    get hasExtraItems() {
      return !!this.max && this.items.length > this.max;
    }
    toggle() {
      this.expanded = !this.expanded;
      this.expandedChange.emit(this.expanded);
    }
    static {
      this.ɵfac = function TuiFilesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFilesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiFilesComponent,
        selectors: [["tui-files"]],
        contentQueries: function TuiFilesComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiItem, 4, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
          }
        },
        inputs: {
          max: "max",
          expanded: "expanded"
        },
        outputs: {
          expandedChange: "expandedChange"
        },
        features: [i0.ɵɵProvidersFeature([tuiGroupOptionsProvider({
          size: 'm',
          collapsed: true,
          orientation: 'vertical'
        })]), i0.ɵɵHostDirectivesFeature([i1$1.TuiGroup])],
        ngContentSelectors: _c0,
        decls: 6,
        vars: 6,
        consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "expanded", 4, "ngIf"], ["class", "t-bottom", 3, "t-bottom_collapsed", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "expanded"], ["tuiGroup", "", 1, "t-extra-items"], [1, "t-bottom"], ["appearance", "outline", "size", "m", "tuiButton", "", "type", "button", 1, "t-button", 3, "click"]],
        template: function TuiFilesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, TuiFilesComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵprojection(2);
            i0.ɵɵtemplate(3, TuiFilesComponent_ng_container_3_Template, 2, 1, "ng-container", 1)(4, TuiFilesComponent_tui_expand_4_Template, 3, 2, "tui-expand", 2)(5, TuiFilesComponent_div_5_Template, 4, 5, "div", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 4, ctx.items == null ? null : ctx.items.changes));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.items);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasExtraItems);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasExtraItems);
          }
        },
        dependencies: [CommonModule, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.AsyncPipe, TuiButton, TuiExpandComponent, TuiGroup],
        styles: ["tui-files{inline-size:100%;overflow:hidden;border-radius:var(--tui-radius-m)}tui-files:empty:empty{display:none}tui-files .t-files{position:relative;display:block;inline-size:100%;block-size:100%;border-radius:var(--tui-radius-m);overflow:hidden}tui-files .t-button{inline-size:100%;border-radius:inherit}tui-files .t-bottom{z-index:3;inline-size:100%;background:var(--tui-background-base);-webkit-mask:none!important;mask:none!important}tui-files .t-bottom_collapsed{box-shadow:var(--tui-shadow-popup);margin-top:-1.5rem}tui-files .t-extra-items{inline-size:100%}tui-files .t-extra-items>*{border-radius:0!important}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiFilesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TuiInputFilesContent {
  constructor() {
    this.breakpoint$ = inject(TuiBreakpointService);
    this.text$ = inject(TUI_INPUT_FILE_TEXTS);
    this.context = injectContext();
    this.component = inject(TuiInputFiles);
  }
  get link$() {
    return this.computeLink$(this.context.$implicit, !!this.component.input?.input.multiple);
  }
  get label$() {
    return this.computeLabel$(this.context.$implicit, !!this.component.input?.input.multiple);
  }
  computeLink$(fileDragged, multiple) {
    return fileDragged ? of('') : this.text$.pipe(map(t => multiple ? t.defaultLinkMultiple : t.defaultLinkSingle));
  }
  computeLabel$(fileDragged, multiple) {
    return fileDragged ? combineLatest([this.breakpoint$, this.text$]).pipe(map(([breakpoint, text]) => {
      if (breakpoint === 'mobile') {
        return '';
      }
      return multiple ? text.dropMultiple : text.drop;
    })) : combineLatest([this.breakpoint$, this.text$]).pipe(map(([breakpoint, text]) => {
      if (breakpoint === 'mobile') {
        return '';
      }
      return multiple ? text.defaultLabelMultiple : text.defaultLabelSingle;
    }));
  }
  static {
    this.ɵfac = function TuiInputFilesContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TuiInputFilesContent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TuiInputFilesContent,
      selectors: [["ng-component"]],
      decls: 5,
      vars: 6,
      consts: [["tuiLink", ""]],
      template: function TuiInputFilesContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "async");
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx.link$));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx.label$), " ");
        }
      },
      dependencies: [AsyncPipe, TuiLink],
      encapsulation: 2
    });
  }
}
__decorate([tuiPure], TuiInputFilesContent.prototype, "computeLink$", null);
__decorate([tuiPure], TuiInputFilesContent.prototype, "computeLabel$", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_INPUT_FILES_DEFAULT_OPTIONS = {
  accept: '',
  multiple: false,
  size: 'm',
  maxFileSize: 30 * 1024 * 1024 // 30 MiB
};
/**
 * Default parameters for input files component
 */
const TUI_INPUT_FILES_OPTIONS = tuiCreateToken(TUI_INPUT_FILES_DEFAULT_OPTIONS);
function tuiInputFilesOptionsProvider(options) {
  return tuiProvideOptions(TUI_INPUT_FILES_OPTIONS, options, TUI_INPUT_FILES_DEFAULT_OPTIONS);
}
let TuiInputFilesValidator = /*#__PURE__*/(() => {
  class TuiInputFilesValidator {
    constructor() {
      this.options = inject(TUI_INPUT_FILES_OPTIONS);
      this.validator = inject(TuiValidator);
      this.accept = this.options.accept;
      this.maxFileSize = this.options.maxFileSize;
    }
    ngOnChanges() {
      this.validate();
    }
    ngOnInit() {
      this.validate();
    }
    validate() {
      this.validator.tuiValidator = Validators.compose([tuiCreateFileFormatValidator(this.accept), tuiCreateFileSizeValidator(this.maxFileSize)]) || Validators.nullValidator;
      this.validator.ngOnChanges();
    }
    static {
      this.ɵfac = function TuiInputFilesValidator_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiInputFilesValidator)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiInputFilesValidator,
        hostVars: 1,
        hostBindings: function TuiInputFilesValidator_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵdomProperty("accept", ctx.accept);
          }
        },
        inputs: {
          accept: "accept",
          maxFileSize: "maxFileSize"
        },
        exportAs: ["tuiInputFilesValidator"],
        features: [i0.ɵɵHostDirectivesFeature([i1$2.TuiValidator]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return TuiInputFilesValidator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiInputFilesDirective = /*#__PURE__*/(() => {
  class TuiInputFilesDirective extends TuiControl {
    constructor() {
      super(...arguments);
      this.host = inject(forwardRef(() => TuiInputFiles));
      this.reject = timer(0, tuiZonefreeScheduler()).pipe(switchMap(() => tuiControlValue(this.control.control)), map(() => tuiFilesRejected(this.control.control)), filter(({
        length
      }) => !!length));
      this.appearance = 'file';
      this.input = tuiInjectElement();
    }
    process(files) {
      const fileOrFiles = this.input.multiple ? [...toArray(this.value()), ...Array.from(files)] : files[0];
      if (fileOrFiles) {
        this.onChange(fileOrFiles);
      }
    }
    onClick(event) {
      if (this.input.readOnly) {
        event.preventDefault();
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiInputFilesDirective_BaseFactory;
        return function TuiInputFilesDirective_Factory(__ngFactoryType__) {
          return (ɵTuiInputFilesDirective_BaseFactory || (ɵTuiInputFilesDirective_BaseFactory = i0.ɵɵgetInheritedFactory(TuiInputFilesDirective)))(__ngFactoryType__ || TuiInputFilesDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiInputFilesDirective,
        selectors: [["input", "tuiInputFiles", ""]],
        hostAttrs: ["type", "file"],
        hostVars: 1,
        hostBindings: function TuiInputFilesDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("blur", function TuiInputFilesDirective_blur_HostBindingHandler() {
              return ctx.onTouched();
            })("click", function TuiInputFilesDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵdomProperty("disabled", ctx.disabled());
          }
        },
        outputs: {
          reject: "reject"
        },
        features: [i0.ɵɵProvidersFeature([tuiAsControl(TuiInputFilesDirective), tuiAppearanceOptionsProvider(TuiInputFilesDirective)]), i0.ɵɵHostDirectivesFeature([i1$3.TuiNativeValidator, i1.TuiWithAppearance, {
          directive: TuiInputFilesValidator,
          inputs: ["accept", "accept", "maxFileSize", "maxFileSize"]
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiInputFilesDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function toArray(value) {
  return value ? coerceArray(value) : EMPTY_ARRAY;
}
let TuiInputFiles = /*#__PURE__*/(() => {
  class TuiInputFiles {
    constructor() {
      this.content = new PolymorpheusComponent(TuiInputFilesContent);
    }
    get fileDragged() {
      return !!this.files && !this.input?.disabled();
    }
    onFilesSelected(input) {
      if (!input?.files) {
        return;
      }
      this.input?.process(input.files);
      input.value = '';
    }
    onDropped({
      dataTransfer
    }) {
      this.files = null;
      if (dataTransfer?.files && !this.input?.disabled()) {
        this.input?.process(dataTransfer.files);
      }
    }
    onDrag(dataTransfer) {
      this.files = dataTransfer?.files;
    }
    static {
      this.ɵfac = function TuiInputFiles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiInputFiles)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiInputFiles,
        selectors: [["label", "tuiInputFiles", ""]],
        contentQueries: function TuiInputFiles_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
            i0.ɵɵcontentQuery(dirIndex, TuiInputFilesDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function TuiInputFiles_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dragover.prevent.zoneless", function TuiInputFiles_dragover_prevent_zoneless_HostBindingHandler() {
              return 0;
            })("drop.prevent", function TuiInputFiles_drop_prevent_HostBindingHandler($event) {
              return ctx.onDropped($event);
            })("dragenter", function TuiInputFiles_dragenter_HostBindingHandler($event) {
              return ctx.onDrag($event.dataTransfer);
            })("dragleave", function TuiInputFiles_dragleave_HostBindingHandler() {
              return ctx.onDrag(null);
            })("change", function TuiInputFiles_change_HostBindingHandler($event) {
              return ctx.onFilesSelected($event.target);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("_dragged", ctx.fileDragged);
          }
        },
        attrs: _c2,
        ngContentSelectors: _c0,
        decls: 2,
        vars: 4,
        consts: [[4, "polymorpheusOutlet", "polymorpheusOutletContext"]],
        template: function TuiInputFiles_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, TuiInputFiles_span_1_Template, 2, 1, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("polymorpheusOutlet", ctx.template || ctx.content)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c1, ctx.fileDragged));
          }
        },
        dependencies: [PolymorpheusOutlet],
        styles: ["label[tuiInputFiles]{position:relative;display:flex;min-block-size:var(--tui-height-l);justify-content:center;align-items:center;text-align:center;border-radius:var(--tui-radius-m);font:var(--tui-font-text-m);overflow-wrap:break-word;padding:0 .5rem}label[tuiInputFiles]>:not(input){position:relative;pointer-events:none}label[tuiInputFiles] input{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;color:transparent;cursor:pointer}label[tuiInputFiles] input:disabled~*{opacity:var(--tui-disabled-opacity)}label[tuiInputFiles] input::-webkit-file-upload-button{display:none}label[tuiInputFiles] input::file-selector-button{display:none}*:disabled label[tuiInputFiles]{pointer-events:none}[tuiAppearance][data-appearance=file]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;border-radius:inherit;box-sizing:border-box;border:1px dashed var(--tui-text-action);outline:none}tui-root._mobile [tuiAppearance][data-appearance=file]{border-style:solid}[tuiInputFiles]._dragged [tuiAppearance][data-appearance=file]{background:var(--tui-background-neutral-1);border-color:var(--tui-text-action-hover)}@media (hover: hover) and (pointer: fine){[tuiAppearance][data-appearance=file]:matches(a,button,select,textarea,input,label):not(:disabled):hover:not(:disabled):not([data-state]){background:var(--tui-background-neutral-1);border-color:var(--tui-text-action-hover)}}@media (hover: hover) and (pointer: fine){[tuiAppearance][data-appearance=file]:is(a,button,select,textarea,input,label):not(:disabled):hover:not(:disabled):not([data-state]){background:var(--tui-background-neutral-1);border-color:var(--tui-text-action-hover)}}[tuiAppearance][data-appearance=file][data-state=hover]{background:var(--tui-background-neutral-1);border-color:var(--tui-text-action-hover)}@media (hover: hover) and (pointer: fine){[tuiAppearance][data-appearance=file][tuiWrapper]:hover:not(._no-hover),[tuiAppearance][data-appearance=file][tuiWrapper][data-state=hover]{background:var(--tui-background-neutral-1);border-color:var(--tui-text-action-hover)}}[tuiAppearance][data-appearance=file]:matches(a,button,select,textarea,input,label):not(:disabled):active:not(:disabled):not([data-state]){background:var(--tui-background-neutral-1-hover)}[tuiAppearance][data-appearance=file]:is(a,button,select,textarea,input,label):not(:disabled):active:not(:disabled):not([data-state]){background:var(--tui-background-neutral-1-hover)}[tuiAppearance][data-appearance=file][data-state=active]{background:var(--tui-background-neutral-1-hover)}[tuiAppearance][data-appearance=file][tuiWrapper]:active:not(._no-active),[tuiAppearance][data-appearance=file][tuiWrapper][data-state=active],[tuiAppearance][data-appearance=file][tuiWrapper][data-state=active]:hover{background:var(--tui-background-neutral-1-hover)}[tuiAppearance][data-appearance=file]:disabled:not([data-state]),[tuiAppearance][data-appearance=file][data-state=disabled]{background:transparent;border-color:var(--tui-text-tertiary)}[tuiAppearance][data-appearance=file][tuiWrapper]:disabled:not([data-state]),[tuiAppearance][data-appearance=file][tuiWrapper][data-state=disabled]{background:transparent;border-color:var(--tui-text-tertiary)}[tuiAppearance][data-appearance=file]:focus-visible:not([data-focus=false]){border:.125rem solid var(--tui-border-focus)}[tuiAppearance][data-appearance=file][data-focus=true]{border:.125rem solid var(--tui-border-focus)}[tuiAppearance][data-appearance=file][tuiWrapper]:not(._focused):has(:focus-visible),[tuiAppearance][data-appearance=file][tuiWrapper]._focused{border:.125rem solid var(--tui-border-focus)}[tuiAppearance][data-appearance=file]:invalid{border-color:var(--tui-status-negative)!important}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiInputFiles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiFileRejectedPipe = /*#__PURE__*/(() => {
  class TuiFileRejectedPipe {
    constructor() {
      this.options = inject(TUI_INPUT_FILES_OPTIONS);
      this.formatSize = inject(TUI_FILE_OPTIONS).formatSize;
      this.text$ = inject(TUI_INPUT_FILE_TEXTS);
      this.unit$ = inject(TUI_DIGITAL_INFORMATION_UNITS);
    }
    transform(file, {
      accept = this.options.accept,
      maxFileSize = this.options.maxFileSize
    } = this.options) {
      const sizeValidator = tuiCreateFileSizeValidator(maxFileSize);
      const formatValidator = tuiCreateFileFormatValidator(accept);
      const control = new FormControl(file);
      return combineLatest([this.text$, this.unit$]).pipe(map(([{
        maxSizeRejectionReason,
        formatRejectionReason
      }, units]) => {
        if (file && formatValidator(control)) {
          return {
            name: file.name,
            size: file.size,
            content: formatRejectionReason
          };
        }
        if (file && sizeValidator(control)) {
          return {
            name: file.name,
            size: file.size,
            content: `${maxSizeRejectionReason}${CHAR_NO_BREAK_SPACE}${this.formatSize(units, maxFileSize)}`
          };
        }
        return null;
      }));
    }
    static {
      this.ɵfac = function TuiFileRejectedPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFileRejectedPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tuiFileRejected",
        type: TuiFileRejectedPipe,
        pure: true
      });
    }
  }
  return TuiFileRejectedPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TuiFiles = [TuiItem, TuiFile, TuiInputFiles, TuiFilesComponent, TuiFileRejectedPipe, TuiInputFilesDirective];

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_FILE_DEFAULT_OPTIONS, TUI_FILE_OPTIONS, TUI_FORMAT_ERROR, TUI_INPUT_FILES_DEFAULT_OPTIONS, TUI_INPUT_FILES_OPTIONS, TUI_SIZE_ERROR, TuiFile, TuiFileRejectedPipe, TuiFiles, TuiFilesComponent, TuiInputFiles, TuiInputFilesContent, TuiInputFilesDirective, TuiInputFilesValidator, tuiCreateFileFormatValidator, tuiCreateFileSizeValidator, tuiFileOptionsProvider, tuiFilesAccepted, tuiFilesRejected, tuiFormatSize, tuiInputFilesOptionsProvider };
